// @flow

import { all, put, takeEvery, call } from "redux-saga/effects";
import type { Action } from "redux-action";
import http from "@http";
import config from "@config";
import { GetClientContext } from "@modules/context/constants/actions";
import actionCreator from "@modules/context/actionCreator";
import settingsActionCreator from "@modules/settings/actionCreator";
import type { ClientResponse } from "@modules/context/types";

type ClientRequest = $Exact<{
  clientId: string,
}>;

type GetClientResponse = $Exact<{
  data: ClientResponse,
}>;

export function* onGetClientContext({
  payload,
}: Action<ClientRequest>): Generator<*, void, GetClientResponse> {
  try {
    if (!payload || !payload.clientId) {
      throw Error("Invalid payload provided");
    }

    const response = yield call(
      http.get,
      `${config.endpointBaseUrl}api/v1/client-admin/client/${payload.clientId}`,
    );

    yield all([
      put(actionCreator.getClientContextSuccess(response.data)),
      put(settingsActionCreator.GetSettings(payload)),
    ]);
  } catch (e) {
    console.error("Saga error: ", e);
    yield put(actionCreator.getClientContextError(e.response));
  }
}

export function* ClientContextSagas(): Generator<*, void, void> {
  yield takeEvery(GetClientContext, onGetClientContext);
}

export default ClientContextSagas;
